<template>
  <div
    :class="[
      'content-row__details',
      isLoading && 'content-row__details--loading',
    ]"
  >
    <div class="content-row__details-top">
      <div
        v-if="skillDiveDescription"
        class="content-row__details-top-description"
        v-html="skillDiveDescription"
      ></div>
    </div>
    <div class="content-row__details-bottom">
      <div class="content-row__details-bottom-content">
        <div class="content-row__details-bottom-tags">
          <PillTagsList
            v-if="keyConceptList.length > 0"
            :tags="keyConceptList"
            @tag-click="tag => $emit('tag-selected', tag)"
          />
          <div
            v-if="isVulnerability"
            class="content-row__details-bottom-vulnerabilities"
          >
            <strong>Governance:</strong> Covering policy, compliance, and
            industry-specific vulnerabilities.
          </div>
        </div>
        <button
          v-tooltip="{
            content: getAccessTooltip,
            placement: 'right-center',
          }"
          class="btn--default-icon-color btn btn--secondary btn--small"
        >
          {{ ctaText }}
          <LockIcon v-if="locked" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { LockIcon } from 'vue-feather-icons'
import { getLearningAreaName } from '@/helpers'
import { mapGetters } from 'vuex'
import { skillDiveLabsCommons } from '@/helpers/mixins'
import PillTagsList from '@/components/properties/PillTagsList.vue'

export default {
  name: 'ContentRowDetails',
  components: {
    LockIcon,
    PillTagsList,
  },
  mixins: [skillDiveLabsCommons],
  emits: ['tag-selected'],
  props: {
    content: {
      type: Object,
      required: true,
    },
    isVulnerability: {
      type: Boolean,
      required: false,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      isSkillDiveB2CUser: 'auth/isSkillDiveB2CUser',
      isAccOwnerOrTeamManager: 'auth/isAccOwnerOrTeamManager',
      isBusinessUser: 'business/isBusinessUser',
    }),
    ctaText() {
      if (this.locked) {
        if (this.isBusinessUser && !this.isAccOwnerOrTeamManager) {
          return 'Request access'
        } else {
          return 'Get access'
        }
      }
      return 'Go to lab'
    },
    getAccessTooltip() {
      if (this.locked) {
        if (this.isSkillDiveB2CUser) {
          return `This lab is part of the ${getLearningAreaName(
            this.content
          )} learning area. Get access.`
        } else if (this.isBusinessUser && !this.isAccOwnerOrTeamManager) {
          return 'This lab is locked. Request access.'
        } else {
          return 'This lab is locked. Get access.'
        }
      }
      return ''
    },
  },
  created() {
    this.labContent = this.content
    this.setSkillDiveTags()
  },
}
</script>
<style scoped lang="scss">
.content-row {
  &__details {
    display: flex;
    gap: 20px;
    flex-direction: column;

    &--loading {
      cursor: not-allowed;
    }
    &-top {
      display: flex;
      flex-flow: column;
      gap: 20px;
      opacity: 1;

      @include desktop {
        flex-flow: row;
      }

      &-description {
        color: var(--dusty-gray);
        font-size: rem(14px);
        font-style: normal;
        font-weight: 450;
        line-height: rem(20px);

        max-width: 800px;

        ::v-deep a {
          color: var(--white);
          text-decoration: underline;

          &:visited {
            color: var(--white);
          }
        }
        ::v-deep img {
          width: 100%;
        }

        ::v-deep p {
          margin: 0;
          text-align: left;
        }

        ::v-deep ul {
          text-align: left;
        }

        ::v-deep ol {
          text-align: left;
        }

        ::v-deep h1 {
          font-size: rem(14px);
          font-style: normal;
          font-weight: 700;
          text-align: left;
        }
      }
    }
    &-bottom {
      display: flex;
      flex-flow: column;
      &-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        button {
          width: 28%;
          @include mobile {
            width: unset;
          }
        }
      }
      &-tags {
        display: flex;
        flex-flow: column;
        gap: 5px;
      }
    }
  }
}
</style>
